import { useAtom } from 'jotai';
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import * as state from './state';

export const HiddenCuboidsPanel = () => {
  const [hiddenCuboidIds, setHiddenCuboidIds] = useAtom(state.hiddenCuboidIds);

  if (hiddenCuboidIds.size === 0) return null;

  const handleUnhideAll = () => setHiddenCuboidIds(new Set<string>());

  return (
    <Box sx={{ paddingY: 0.5 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={1}>
          <VisibilityOffIcon fontSize="medium" />
          <Typography variant="body1">Hidden cuboids: {hiddenCuboidIds.size}</Typography>
        </Stack>
        <Tooltip title="Unhide all">
          <IconButton size="medium" onClick={handleUnhideAll}>
            <VisibilityIcon fontSize="medium" />
          </IconButton>
        </Tooltip>
      </Stack>
    </Box>
  );
};
